import { Box, CircularProgress } from '@mui/material'
import { Button } from 'Common/Supplyvue-ui'
import { SaveParametersProps } from '../SystemOfRecords.types'

export const SaveParameters = ({
  handleUpdate,
  isRunning = false,
  isDisabled = false,
  handleRunPlan,
}: SaveParametersProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'right',
      }}
    >
      <Box
        mt={2}
        sx={{
          marginRight: '8px',
        }}
      >
        <Button
          onClick={handleRunPlan}
          label="Run plan"
          disabled={isRunning || isDisabled}
          variant="contained"
        >
          {isRunning && (
            <CircularProgress
              color="inherit"
              size={16}
              sx={{ marginRight: '8px' }}
            />
          )}
          {'Run plan'}
        </Button>
      </Box>
      <Box mt={2}>
        <Button
          onClick={handleUpdate}
          label="Update parameters"
          disabled={isDisabled}
          variant="contained"
        >
          {isRunning && (
            <CircularProgress
              color="inherit"
              size={16}
              sx={{ marginRight: '8px' }}
            />
          )}
          Update parameters
        </Button>
      </Box>
    </Box>
  )
}
